import { useDispatch, useSelector } from "react-redux";

import { JobPostCard } from "./";
import JobsCompWrapper from "../../StylesWrappers/postJobsWrappers/allPostJobsCards";
import { AppDispatch, RootState } from "../../store";
import { ConfirmationModal } from "../General/helpers";
import { setCloseConfirmationModal } from "../../features/general/generalSlice";
import Overlay from "../General/overlay";
import Loader from "../General/Loader";

interface AllPostJobsCompProps {
  handleJobDetails: (_id: string) => void;
  initialSaveForLater?: any;
  handleSaveForLater?: (_id: string) => void;
}

const AllPostJobsComp = ({
  handleJobDetails,
  initialSaveForLater,
  handleSaveForLater,
}: AllPostJobsCompProps) => {
  const { allPostJobs } = useSelector(
    (store: RootState) => store.allPostJobsStore
  );
  const { openConfirmationModal } = useSelector(
    (store: RootState) => store.generalStore
  );
  const { isSaveForLaterLoading } = useSelector(
    (store: RootState) => store.saveForLaterStore
  );

  const dispatch = useDispatch<AppDispatch>();

  return (
    <>
      {isSaveForLaterLoading && (
        <Overlay>
          <Loader />
        </Overlay>
      )}
      <ConfirmationModal
        handleCloseModal={() => dispatch(setCloseConfirmationModal())}
        handleRemoveItem={handleSaveForLater}
        isOverlayModal={openConfirmationModal}
        modalMessage="Are you sure you want to save this job for later"
      />
      <JobsCompWrapper>
        {allPostJobs?.map((each) => {
          const {
            _id,
            position,
            company,
            jobType,
            jobLocation,
            jobEmail,
            jobUrl,
          }: any = each;
          return (
            <JobPostCard
              key={_id}
              handleJobDetails={() => handleJobDetails(_id)}
              initialSaveForLater={() => initialSaveForLater(_id)}
              position={position}
              company={company}
              jobType={jobType}
              jobLocation={jobLocation}
              jobEmail={jobEmail}
              jobUrl={jobUrl}
            />
          );
        })}
      </JobsCompWrapper>
    </>
  );
};

export default AllPostJobsComp;
